import { useState, useRef, useEffect } from "react";
import {
  Container,
  TextField,
  Grid,
  Box,
  Button,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Divider,
  TableRow,
  Checkbox,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  Select,
  AccordionDetails,
  Typography,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useFetch from "../utils/UseFetch";
import { Buffer } from "buffer";
import { useLocation, Link } from "react-router-dom";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { base64ToBlob } from "../HelperFx/common.js";
import axios from "axios";
import { Row, Col } from "reactstrap";

const REACT_APP_API_USERNAME = process.env.REACT_APP_API_USERNAME;
const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_BIDDING_API_DATA_URL =
  process.env.REACT_APP_BIDDING_API_DATA_URL;
const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

const REACT_UNAME = REACT_APP_API_USERNAME;
const REACT_PWD = REACT_APP_API_PASSWORD;
const REACT_DATA_URL = REACT_APP_API_DATA_URL;
const REACT_ACTION_URL = REACT_APP_BIDDING_API_DATA_URL;
const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;

const BidDetailsPage = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchColumn, setSearchColumn] = useState("no");
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isVendorInRFP, setIsVendorInRFP] = useState(false);
  const [loadingPaymentStatus, setLoadingPaymentStatus] = useState(true);
  const componentRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState([]);

  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );

  const {
    data: itemsLines,
    loading,
    error,
  } = useFetch(
    `${REACT_DATA_URL}RFPLines?${REACT_APP_COMPANY_URL}&$filter=docNo eq '${location.state?.bidNo}'`,
    token,
  );

  const {
    data: scoringCriteria,
  } = useFetch(
    `${REACT_DATA_URL}ScoringCriteria?${REACT_APP_COMPANY_URL}&$filter=rfpNo eq '${location.state?.bidNo}'`,
    token,
  );

  const {
    data: rfpVendorSubform,
  } = useFetch(
    `${REACT_DATA_URL}RFPVendors?${REACT_APP_COMPANY_URL}&$filter=rfpNo eq '${location.state?.bidNo}'`,
    token,
  );

  const storedVendorNo = sessionStorage.getItem("vendorNo");
  const filteredVendorSubform = rfpVendorSubform?.value?.filter(
    (vendor) => vendor.vendorNo === storedVendorNo,
  );
  // setIsVendorInRFP(filteredVendorSubform?.length > 0);
  useEffect(() => {
    setIsVendorInRFP(filteredVendorSubform?.length > 0);
  }, [filteredVendorSubform]);

  const itemsData = itemsLines?.value;
  const scoringData = scoringCriteria?.value;

  const filteredItems =
    itemsData?.filter((item) => {
      console.log(item);
      console.log(searchColumn);
      console.log(item[searchColumn]);
      return item[searchColumn]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    }) || [];

  const handleSelectItem = (item) => {
    const selectedIndex = selectedItems.indexOf(item);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedItems, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1),
      );
    }

    setSelectedItems(newSelected);
  };

  const handleMasterChange = () => {
    if (selectedItems.length === filteredItems.length) {
      setSelectedItems([]); // Deselect all items
    } else {
      setSelectedItems(filteredItems); // Select all items
    }
  };

  const ApplyForBid = () => {
    const vendorNo = sessionStorage.getItem("vendorNo");
    const bidDetails = {
      vendorNo: vendorNo,
      rfp: location.state?.bidNo,
    };

    console.log(bidDetails);

    fetch(`${REACT_ACTION_URL}createBid?${REACT_APP_COMPANY_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
      body: JSON.stringify(bidDetails),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `Error creating bid: ${data.error.message}`,
          });
          console.error("Error creating bid:", data.error);
        } else {
          console.log("Bid created successfully:", data.value);
          fetch(
            `${REACT_APP_API_DATA_URL}bidheader?${REACT_APP_COMPANY_URL}&$filter= no eq '${data.value}'`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Basic ${token}`,
              },
            },
          )
            .then((response) => response.json())
            .then((data) => {
              console.log("test:", data);
              navigate(`/applied-for-bid`, {
                state: {
                  bidNo: data.value[0]?.no,
                  bidDescription: data.value[0]?.description,
                  bidDueDate: data.value[0]?.validToDate,
                  bidStatus: data.value[0]?.Status,
                  bidProcurementMethod: location.state?.bidProcurementMethod,
                  bidPostingDate: data.value[0]?.postingDate,
                  from: location.state?.from,
                  rfpNo: data.value[0]?.rfpNo,
                },
              });
            });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Error creating bid: ${error.message}`,
        });
        console.error("Error creating bid:", error);
      });
  };

  const getDocumentAttachments = async (documentNo) => {
    // setIsModalLoading(true);
    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}&$filter=No eq '${documentNo}' and TableID eq 50295`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      // console.log('Attachments:', response.data); // Debug log
      setSelectedFile(response.data.value);
    } catch (error) {
      // console.error('Error fetching attachments:', error);
      Swal.fire("Error", "Failed to load attachments", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const downloadAttachment = async (systemId) => {
    // setIsModalLoading(true);
    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      // console.log('Attachment response:', response.data.FileName); // Debug log
      const ext = response.data?.FileExtension;
      const blob = base64ToBlob(response.data?.FileContentBase64, ext);
      // console.log(blob);
      // console.log(ext);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${systemId}.${ext}`; // Set the desired file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    } finally {
      // setIsModalLoading(false);
    }
  };

  // Excel Download Function
  const downloadExcel = () => {
    const headers = [
      "id",
      "Type",
      "No",
      "Product Description",
      "Pack Size (Unit of Measure)",
      "Product Lot",
      "Quantity",
      "Unit Cost",
      "Vat Product Posting Group",
      "Document Type",
      "Line No.",
      "Document No.",
      "Registration number (NDA).",
      "Manufacturer/Supplier Product Description",
      "Brand Name",
      "Manufacturer",
      "Country Of Origin",
      "Supplier Currency",
      "CFR Kampala Unit Price",
      "Payment Terms",
      "Prepayment %",
      "Lead Time For Ex Stock-Week (Period for the supplier to have ex works stock ready for dispatch)",
      "Lead Time For Fresh Prod in Days",
      "Total Shelf Life of Product (Expiry date of stock)",
      "Batch size (Qty)",
      "Carton Dimension",
      "Total Gross weight for the consignment in (KG)",
      "Total Gross volume for the consignment in (CBM)",
      "Cartons per pallets",
      "Est. No of pallets",
      "Est. no of Containers",
      "DDP Jms Unit Price",
      "ExWorks Unit Price",
      "Comments/Remarks (any other information not described in the table)",
      "Is BUBU",
      "Is Consignment",
    ];

    const rows = (selectedItems.length > 0 ? selectedItems : filteredItems).map(
      (item) => [
        item.id || "0",
        item.type || "0",
        item.no || "0",
        item.description || "0",
        item.uom || "0",
        item.productLot || "0",
        item.Quantity || "0",
        item.unitCost || "0",
        item.VatProductGr || "",
        item.documentType || "0",
        item.lineNo || "0",
        item.docNo || "0",
        item.ndaRegNo || "",
        item.manufacturerSupplierProductDescription || "",
        item.brandName || "",
        item.manufacturer || "",
        item.countryOfOrigin || "",
        item.supplierCurrency || "",
        item.cfrKampalaUnitPrice || "",
        item.paymentTerms || "",
        item.prepaymentPercentage || 0,
        item.leadTimeForExWorksInDays || 0,
        item.leadTimeForFreshProdInDays || 0,
        item.totalShelfLifeOfProduct || "",
        item.qtyPerCarton || "",
        item.cartonDimension || "",
        item.weightPerCarton || "",
        item.volumePerCarton || "",
        item.cartonsPerPallets || "",
        item.noOfPallets || "",
        item.noOfContainers || "",
        item.exUnitPrice || "",
        item.ddpJmsUnitPrice || "0",
        item.commentsRemarks || "",
        item.isBUBU || "",
        item.isCosignment || "",
      ],
    );

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bid Items");
    XLSX.writeFile(workbook, `Bid_${location.state?.bidNo}_Items.xlsx`);
  };

  // PDF Download Function
  const downloadPDF = () => {
    const input = componentRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Bid_${location.state?.bidNo}_Items.pdf`);
    });
  };

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        const vendorNo = sessionStorage.getItem("vendorNo");
        const rfpNo = location.state?.bidNo;

        const response = await fetch(
          `${REACT_APP_EXPRESS_SERVER}/payments/vendor/${vendorNo}/rfp/${rfpNo}`,
        );

        if (response.ok) {
          const data = await response.json();
          if (data.length > 0) {
            console.log(data[0].status);
            setPaymentStatus(data[0].status);
          }
        }
      } catch (error) {
        console.error("Error fetching payment status:", error);
      } finally {
        setLoadingPaymentStatus(false);
      }
    };

    if (location.state?.requirePayment) {
      fetchPaymentStatus();
    } else {
      setLoadingPaymentStatus(false);
    }
  }, [location.state?.bidNo, location.state?.requirePayment]);

  const UploadPaymentReciepts = () => {
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileSelect = (event) => {
      setSelectedFile(event.target.files[0]);
    };

    const handleUploadClick = () => {
      fileInputRef.current.click();
    };

    const handleUpload = () => {
      if (!selectedFile) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please select a file to upload",
        });
        return;
      }

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("RFPNo", location.state?.bidNo);
      formData.append("Vendor", sessionStorage.getItem("vendorNo"));
      formData.append("UserName", sessionStorage.getItem("username"));

      fetch(`${REACT_APP_EXPRESS_SERVER}/payments`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Failed to upload file. Please try again. ${response.status} ${response.statusText}`,
            );
          }
          return response.json();
        })
        .then((data) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Receipt uploaded successfully!",
          });
          setSelectedFile(null);
          setPaymentStatus("REQUESTED"); // Update local state
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              error.message || "Failed to upload receipt. Please try again.",
          });
        });

      Swal.fire({
        title: "Uploading Receipt...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      setOpenUploadDialog(false);
    };

    return (
      <>
        {storedVendorNo && (
          <Button
            variant="contained"
            color={paymentStatus === "REJECTED" ? "error" : "success"}
            onClick={() => setOpenUploadDialog(true)}
          >
            {paymentStatus === "REQUESTED"
              ? "Receipt under review"
              : paymentStatus === "REJECTED"
                ? "Receipt Rejected - Upload Again"
                : "Upload Payment Receipt"}
          </Button>
        )}

        <Dialog
          open={openUploadDialog}
          onClose={() => setOpenUploadDialog(false)}
        >
          <DialogTitle>Upload Payment Receipt</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2, mb: 2 }}>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelect}
                style={{ display: "none" }}
                accept=".pdf,.jpg,.jpeg,.png"
              />
              <Button variant="contained" onClick={handleUploadClick} fullWidth>
                Select File
              </Button>
              {selectedFile && (
                <Typography variant="body2" sx={{ mt: 2 }}>
                  Selected file: {selectedFile.name}
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setOpenUploadDialog(false)}
              color="error"
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpload}
              variant="contained"
              color="success"
              disabled={!selectedFile}
            >
              Upload
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const PrintableTable = () => (
    <div ref={componentRef} style={{ padding: "20px" }}>
      <h2>Bid Items - {location.state?.bidNo}</h2>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 1 }}></TableCell>
              <TableCell sx={{ py: 1 }}>Type</TableCell>
              <TableCell sx={{ py: 1 }}>Product Lot</TableCell>
              <TableCell sx={{ py: 1 }}>No</TableCell>
              <TableCell sx={{ py: 1 }}>Unit of Measure</TableCell>
              <TableCell sx={{ py: 1 }}>Description</TableCell>
              <TableCell sx={{ py: 1 }}>Quantity</TableCell>
              <TableCell sx={{ py: 1 }}>Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedItems.length > 0 ? (
              selectedItems.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ py: 1 }}>{item.type}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.productLot}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.no}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.uom}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.description}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.Quantity}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.uom}</TableCell>
                  <TableCell sx={{ py: 1 }}></TableCell>
                </TableRow>
              ))
            ) : filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ py: 1 }}>{item.type}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.productLot}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.no}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.uom}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.description}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.Quantity}</TableCell>
                  <TableCell sx={{ py: 1 }}>{item.uom}</TableCell>
                  <TableCell sx={{ py: 1 }}></TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No items found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  const expressInterestInBid = () => {
    const vendorNo = sessionStorage.getItem("vendorNo");
    const rfpNo = location.state?.bidNo;

    console.log(
      "Expressing interest in bid for vendor:",
      vendorNo,
      "and RFP:",
      rfpNo,
    );

    fetch(`${REACT_ACTION_URL}InterestInRFP?${REACT_APP_COMPANY_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
      body: JSON.stringify({
        vendorNo: vendorNo,
        rfpNo: rfpNo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: data.error.message,
          });
        } else {
          setIsVendorInRFP(true);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Interest in bid successfully registered",
          }).then(() => {
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to register interest in bid",
        });
        console.error("Error:", error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedItems = filteredItems.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Bid Details Section */}
      <Box component="form" noValidate autoComplete="off" sx={{ mb: 4 }}>
        <Grid container spacing={2}>
          {/* First Row */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="No"
              variant="outlined"
              value={location.state?.bidNo}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="Procurement Method"
              variant="outlined"
              value={location.state?.bidProcurementMethod}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="Posting Date"
              variant="outlined"
              value={location.state?.bidPostingDate}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          {/* Third Row */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="Valid To Date"
              variant="outlined"
              value={location.state?.bidDueDate}
              InputProps={{ readOnly: true }}
              sx={{ mt: 2 }} // Add margin-top for better spacing
            />
          </Grid>

          {/* Second Row */}
          <Grid item xs={12} sm={6} md={8}>
            <TextField
              fullWidth
              size="small"
              label="Subject of Procurement"
              variant="outlined"
              rows={3}
              value={location.state?.bidDescription}
              InputProps={{ readOnly: true }}
              sx={{ mt: 2 }} // Add margin-top for better spacing
            />
          </Grid>
        </Grid>
      </Box>

      {/* RFP Scoring Criteria Table */}
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={{ fontWeight: "bold", fontSize: 16, ml: 2 }}>
            Scoring Criteria
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Scoring Criteria Code</TableCell>
                  <TableCell>Description</TableCell>
                  {/* <TableCell>Weight Percentage</TableCell> */}
                  <TableCell>Score Type</TableCell>
                  {/* <TableCell>Price Scoring Method</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {scoringData?.length > 0 ? (
                  scoringData.map((criteria, index) => (
                    <TableRow key={index}>
                      <TableCell>{criteria.scoringCriteria}</TableCell>
                      <TableCell>{criteria.description}</TableCell>
                      {/* <TableCell>{criteria.weightPercentage}</TableCell> */}
                      <TableCell>{criteria.scoreType}</TableCell>
                      {/* <TableCell>{criteria.priceScoringmethod}</TableCell> */}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No scoring criteria found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>

      <Divider sx={{ mb: 4, color: "black", height: 3 }} />

      {/* Search Bar and Download Buttons */}
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={2} alignItems="center">
          {/* Search Section */}
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Box display="flex" alignItems="center">
              <FormControl
                variant="outlined"
                size="small"
                sx={{ mr: 2, minWidth: 120 }}
              >
                <InputLabel>Search By</InputLabel>
                <Select
                  value={searchColumn}
                  onChange={(e) => setSearchColumn(e.target.value)}
                  label="Search By"
                >
                  <MenuItem value="no">No</MenuItem>
                  <MenuItem value="description">Description</MenuItem>
                  <MenuItem value="productLot">ProductLot</MenuItem>
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                placeholder="Search items..."
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Box>
          </Grid>
          {/* Buttons Section */}
          <Grid item xs={12} sm={4} md={6} lg={8}>
            <Box
              display="flex"
              justifyContent="flex-end"
              flexWrap="wrap"
              gap={1}
            >
              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={downloadExcel}
              >
                Excel
              </Button>
              <Button
                data-bs-toggle="modal"
                data-bs-target="#refDocuments"
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => getDocumentAttachments(location.state?.bidNo)}
              >
                Reference Documents
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => setOpenPreview(true)}
              >
                PDF
              </Button>

              {(location.state?.from === "active" ||
                location.state?.from === "private") && (
                <>
                  {location.state?.requirePayment ? (
                    paymentStatus === "ACCEPTED" ? (
                      isVendorInRFP ? (
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: "green" }}
                          onClick={ApplyForBid}
                        >
                          Apply On Bid
                        </Button>
                      ) : (
                        storedVendorNo && (
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "green" }}
                            onClick={expressInterestInBid}
                          >
                            Interest In Bid
                          </Button>
                        )
                      )
                    ) : (
                      <UploadPaymentReciepts />
                    )
                  ) : isVendorInRFP ? (
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "green" }}
                      onClick={ApplyForBid}
                    >
                      Apply On Bid
                    </Button>
                  ) : (
                    !!storedVendorNo && (
                      <Button
                        variant="contained"
                        sx={{ backgroundColor: "green" }}
                        onClick={expressInterestInBid}
                      >
                        Interest In Bid
                      </Button>
                    )
                  )}
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      <div
        className="modal fade"
        id="refDocuments"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Attachments
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <Row className="mb-2">
                <Col md={12}>
                  {selectedFile.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="table table-striped table-sm mb-4">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>File</th>
                            <th>File Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedFile.map((a, k) => (
                            <tr key={k} className="py-1">
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadAttachment(a.SystemId);
                                  }}
                                >
                                  {a.FileName}
                                </Link>
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {a.fileType}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-file-question text-warning display-4" />
                      </div>
                      <h6>No file attached</h6>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              {/* <button type="button" class="btn btn-primary">Save changes</button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Bid Items Table */}
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Bid Items</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper} sx={{ mb: 4 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ py: 0, height: 10 }}>
                    <Checkbox
                      checked={selectedItems.length === filteredItems.length}
                      onChange={handleMasterChange}
                    />
                  </TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>Type</TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>Product Lot</TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>No</TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>
                    Unit of Measure
                  </TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>Description</TableCell>
                  <TableCell sx={{ py: 0, height: 10 }}>Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedItems.length > 0 ? (
                  paginatedItems.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ py: 0 }}>
                        <Checkbox
                          checked={selectedItems.indexOf(item) !== -1}
                          onChange={() => handleSelectItem(item)}
                        />
                      </TableCell>
                      <TableCell sx={{ py: 0 }}>{item.type}</TableCell>
                      <TableCell sx={{ py: 0 }}>{item.productLot}</TableCell>
                      <TableCell sx={{ py: 0 }}>{item.no}</TableCell>
                      <TableCell sx={{ py: 0 }}>{item.uom}</TableCell>
                      <TableCell sx={{ py: 0 }}>{item.description}</TableCell>
                      <TableCell sx={{ py: 0 }}>{item.Quantity}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No items found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredItems.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </AccordionDetails>
      </Accordion>

      {/* PDF Preview Dialog */}
      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
      >
        <DialogTitle>PDF Preview</DialogTitle>
        <DialogContent>
          <PrintableTable />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPreview(false)}>Cancel</Button>
          <Button onClick={downloadPDF} color="primary">
            Download PDF
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default BidDetailsPage;
